import {
  showProfile as showProfileApi,
  updatePersonalInfo as updatePersonalInfoApi,
  updateMedicalHistory as updateMedicalHistoryApi,
  updatePreferences as updatePreferencesApi,
  createConsent as createConsentApi,
  updateInsurance as updateInsuranceApi
} from './api'

let showProfile = () => dispatch => {
  return showProfileApi()
}

let updatePersonalInfo = (data) => dispatch => {
  return updatePersonalInfoApi(data)
}

let updateMedicalHistory = (data) => dispatch => {
  return updateMedicalHistoryApi(data)
}

let updatePreferences = (data) => dispatch => {
  return updatePreferencesApi(data)
}

let createConsent = (data) => dispatch => {
  return createConsentApi(data)
}

let updateInsurance = (data) => dispatch => {
  return updateInsuranceApi(data)
}

export {
  showProfile,
  updatePersonalInfo,
  updateMedicalHistory,
  updatePreferences,
  createConsent,
  updateInsurance
}
